import React, { useState, useContext, useEffect } from "react";

import "./PAlauncher.css";

import { PAloginSBwidget, PAloginSBemail} from './PAloginSBs';

// import PAloginSettings from './login/PAloginSettings';



import {
  InputCopy,
  FormGroup,
  Select,
  Tooltip,
  StatusDot,
  Checkbox,
  Subheader,
  Button,
  Head,
  Card,
  Input,
  RadioGroup,
  Switch,
  Icon,
  ButtonAction,
  Tag,
  Notification
} from "xsolla-uikit";

import {
  PAchart1,
  PAloginUsersFake,
  PAchartMap
} from "./PAcharts";
import {
  PAlogin0fake,
  PAloginSocialfake,

  PAchart1fake,
  PAchart2
} from "./PAchart2";

import PAusersSubscribers from "./support/PAusersSubscribers";

import CardNew from "./PAcardNew";
import { ContextConsumer } from "../App";
import { Link } from "react-router-dom";
import { IntlProvider } from "react-intl";
import merge from "deepmerge";

import SwitchExample from "./SwitchExample";
import PAContentBlock from "./PAContentBlock";



export default function PAloginSocials() {
  return (
    <FormGroup indentation="lg">



    <div className="social-connections__grid-container">
      <div className="social-connections__container">
        <div className="connection-tile">
          <div className="connection-tile__header">
            <span className="connection-tile__title">Amazon</span>
            <img
              className="connection-tile__image"
              src="//cdn.xsolla.net/publisher-v4/amazon.a4d4fb.svg"
            />
          </div>
          <div className="connection-tile__action">
            <span className="connection-tile__action_connected">
              <i
                className="xsui-icon xsui-icon-checkmark"
                style={{ fontSize: 24, color: "inherit" }}
              />{" "}
              Connected
            </span>
          </div>
        </div>
        <div className="connection-tile">
          <div className="connection-tile__header">
            <span className="connection-tile__title">Baidu</span>
            <img
              className="connection-tile__image"
              src="//cdn.xsolla.net/publisher-v4/baidu.ff6fb6.svg"
            />
          </div>
          <div className="connection-tile__action">
            <span className="connection-tile__action_connected">
              <i
                className="xsui-icon xsui-icon-checkmark"
                style={{ fontSize: 24, color: "inherit" }}
              />{" "}
              Connected
            </span>
          </div>
        </div>
        <div className="connection-tile">
          <div className="connection-tile__header">
            <span className="connection-tile__title">Battle.net</span>
            <img
              className="connection-tile__image"
              src="//cdn.xsolla.net/publisher-v4/battlenet.194c17.svg"
            />
          </div>
          <div className="connection-tile__action">
            <span className="connection-tile__action_connected">
              <i
                className="xsui-icon xsui-icon-checkmark"
                style={{ fontSize: 24, color: "inherit" }}
              />{" "}
              Connected
            </span>
          </div>
        </div>
        <div className="connection-tile">
          <div className="connection-tile__header">
            <span className="connection-tile__title">
              China Telecom
            </span>
            <img
              className="connection-tile__image"
              src="//cdn.xsolla.net/publisher-v4/china_telecom.78932c.svg"
            />
          </div>
          <div className="connection-tile__action">
            <span className="connection-tile__action_connected">
              <i
                className="xsui-icon xsui-icon-checkmark"
                style={{ fontSize: 24, color: "inherit" }}
              />{" "}
              Connected
            </span>
          </div>
        </div>
        <div className="connection-tile">
          <div className="connection-tile__header">
            <span className="connection-tile__title">Discord</span>
            <img
              className="connection-tile__image"
              src="//cdn.xsolla.net/publisher-v4/discord.3088d1.svg"
            />
          </div>
          <div className="connection-tile__action">
            <span className="connection-tile__action_connected">
              <i
                className="xsui-icon xsui-icon-checkmark"
                style={{ fontSize: 24, color: "inherit" }}
              />{" "}
              Connected
            </span>
          </div>
        </div>
        <div className="connection-tile">
          <div className="connection-tile__header">
            <span className="connection-tile__title">Facebook</span>
            <img
              className="connection-tile__image"
              src="//cdn.xsolla.net/publisher-v4/facebook.7e75cc.svg"
            />
          </div>
          <div className="connection-tile__action">
            <span className="connection-tile__action_connected">
              <i
                className="xsui-icon xsui-icon-checkmark"
                style={{ fontSize: 24, color: "inherit" }}
              />{" "}
              Connected
            </span>
          </div>
        </div>
        <div className="connection-tile">
          <div className="connection-tile__header">
            <span className="connection-tile__title">GitHub</span>
            <img
              className="connection-tile__image"
              src="//cdn.xsolla.net/publisher-v4/github.a0b08e.svg"
            />
          </div>
          <div className="connection-tile__action">
            <span className="connection-tile__action_connected">
              <i
                className="xsui-icon xsui-icon-checkmark"
                style={{ fontSize: 24, color: "inherit" }}
              />{" "}
              Connected
            </span>
          </div>
        </div>
        <div className="connection-tile">
          <div className="connection-tile__header">
            <span className="connection-tile__title">Google</span>
            <img
              className="connection-tile__image"
              src="//cdn.xsolla.net/publisher-v4/google.bf6999.svg"
            />
          </div>
          <div className="connection-tile__action">
            <span className="connection-tile__action_connected">
              <i
                className="xsui-icon xsui-icon-checkmark"
                style={{ fontSize: 24, color: "inherit" }}
              />{" "}
              Connected
            </span>
          </div>
        </div>
        <div className="connection-tile">
          <div className="connection-tile__header">
            <span className="connection-tile__title">Instagram</span>
            <img
              className="connection-tile__image"
              src="//cdn.xsolla.net/publisher-v4/instagram.a79512.svg"
            />
          </div>
          <div className="connection-tile__action">
            <span className="connection-tile__action_connected">
              <i
                className="xsui-icon xsui-icon-checkmark"
                style={{ fontSize: 24, color: "inherit" }}
              />{" "}
              Connected
            </span>
          </div>
        </div>
        <div className="connection-tile">
          <div className="connection-tile__header">
            <span className="connection-tile__title">Kakao</span>
            <img
              className="connection-tile__image"
              src="//cdn.xsolla.net/publisher-v4/kakao.ce857a.svg"
            />
          </div>
          <div className="connection-tile__action">
            <span className="connection-tile__action_connected">
              <i
                className="xsui-icon xsui-icon-checkmark"
                style={{ fontSize: 24, color: "inherit" }}
              />{" "}
              Connected
            </span>
          </div>
        </div>
        <div className="connection-tile">
          <div className="connection-tile__header">
            <span className="connection-tile__title">LinkedIn</span>
            <img
              className="connection-tile__image"
              src="//cdn.xsolla.net/publisher-v4/linkedin.7e5570.svg"
            />
          </div>
          <div className="connection-tile__action">
            <span className="connection-tile__action_connected">
              <i
                className="xsui-icon xsui-icon-checkmark"
                style={{ fontSize: 24, color: "inherit" }}
              />{" "}
              Connected
            </span>
          </div>
        </div>
        <div className="connection-tile">
          <div className="connection-tile__header">
            <span className="connection-tile__title">Mail.ru</span>
            <img
              className="connection-tile__image"
              src="//cdn.xsolla.net/publisher-v4/mailru.78b14e.svg"
            />
          </div>
          <div className="connection-tile__action">
            <span className="connection-tile__action_connected">
              <i
                className="xsui-icon xsui-icon-checkmark"
                style={{ fontSize: 24, color: "inherit" }}
              />{" "}
              Connected
            </span>
          </div>
        </div>
        <div className="connection-tile">
          <div className="connection-tile__header">
            <span className="connection-tile__title">Microsoft</span>
            <img
              className="connection-tile__image"
              src="//cdn.xsolla.net/publisher-v4/microsoft.f38f28.svg"
            />
          </div>
          <div className="connection-tile__action">
            <span className="connection-tile__action_connected">
              <i
                className="xsui-icon xsui-icon-checkmark"
                style={{ fontSize: 24, color: "inherit" }}
              />{" "}
              Connected
            </span>
          </div>
        </div>
        <div className="connection-tile">
          <div className="connection-tile__header">
            <span className="connection-tile__title">MSN</span>
            <img
              className="connection-tile__image"
              src="//cdn.xsolla.net/publisher-v4/msn.3f4627.svg"
            />
          </div>
          <div className="connection-tile__action">
            <span className="connection-tile__action_connected">
              <i
                className="xsui-icon xsui-icon-checkmark"
                style={{ fontSize: 24, color: "inherit" }}
              />{" "}
              Connected
            </span>
          </div>
        </div>
        <div className="connection-tile">
          <div className="connection-tile__header">
            <span className="connection-tile__title">Naver</span>
            <img
              className="connection-tile__image"
              src="//cdn.xsolla.net/publisher-v4/naver.fb1493.svg"
            />
          </div>
          <div className="connection-tile__action">
            <span className="connection-tile__action_connected">
              <i
                className="xsui-icon xsui-icon-checkmark"
                style={{ fontSize: 24, color: "inherit" }}
              />{" "}
              Connected
            </span>
          </div>
        </div>
        <div className="connection-tile">
          <div className="connection-tile__header">
            <span className="connection-tile__title">
              Odnoklassniki
            </span>
            <img
              className="connection-tile__image"
              src="//cdn.xsolla.net/publisher-v4/ok.245bf3.svg"
            />
          </div>
          <div className="connection-tile__action">
            <span className="connection-tile__action_connected">
              <i
                className="xsui-icon xsui-icon-checkmark"
                style={{ fontSize: 24, color: "inherit" }}
              />{" "}
              Connected
            </span>
          </div>
        </div>
        <div className="connection-tile">
          <div className="connection-tile__header">
            <span className="connection-tile__title">PayPal</span>
            <img
              className="connection-tile__image"
              src="//cdn.xsolla.net/publisher-v4/paypal.ebc3a8.svg"
            />
          </div>
          <div className="connection-tile__action">
            <span className="connection-tile__action_connected">
              <i
                className="xsui-icon xsui-icon-checkmark"
                style={{ fontSize: 24, color: "inherit" }}
              />{" "}
              Connected
            </span>
          </div>
        </div>
        <div className="connection-tile">
          <div className="connection-tile__header">
            <span className="connection-tile__title">Pinterest</span>
            <img
              className="connection-tile__image"
              src="//cdn.xsolla.net/publisher-v4/pinterest.6003b4.svg"
            />
          </div>
          <div className="connection-tile__action">
            <span className="connection-tile__action_connected">
              <i
                className="xsui-icon xsui-icon-checkmark"
                style={{ fontSize: 24, color: "inherit" }}
              />{" "}
              Connected
            </span>
          </div>
        </div>
        <div className="connection-tile">
          <div className="connection-tile__header">
            <span className="connection-tile__title">QQ</span>
            <img
              className="connection-tile__image"
              src="//cdn.xsolla.net/publisher-v4/qq.472797.svg"
            />
          </div>
          <div className="connection-tile__action">
            <span className="connection-tile__action_connected">
              <i
                className="xsui-icon xsui-icon-checkmark"
                style={{ fontSize: 24, color: "inherit" }}
              />{" "}
              Connected
            </span>
          </div>
        </div>
        <div className="connection-tile">
          <div className="connection-tile__header">
            <span className="connection-tile__title">Reddit</span>
            <img
              className="connection-tile__image"
              src="//cdn.xsolla.net/publisher-v4/reddit.a1d74a.svg"
            />
          </div>
          <div className="connection-tile__action">
            <span className="connection-tile__action_connected">
              <i
                className="xsui-icon xsui-icon-checkmark"
                style={{ fontSize: 24, color: "inherit" }}
              />{" "}
              Connected
            </span>
          </div>
        </div>
        <div className="connection-tile">
          <div className="connection-tile__header">
            <span className="connection-tile__title">Steam</span>
            <img
              className="connection-tile__image"
              src="//cdn.xsolla.net/publisher-v4/steam.1f1294.svg"
            />
          </div>
          <div className="connection-tile__action">
            <span className="connection-tile__action_connected">
              <i
                className="xsui-icon xsui-icon-checkmark"
                style={{ fontSize: 24, color: "inherit" }}
              />{" "}
              Connected
            </span>
          </div>
        </div>
        <div className="connection-tile">
          <div className="connection-tile__header">
            <span className="connection-tile__title">Twitch.tv</span>
            <img
              className="connection-tile__image"
              src="//cdn.xsolla.net/publisher-v4/twitch.5190ac.svg"
            />
          </div>
          <div className="connection-tile__action">
            <span className="connection-tile__action_connected">
              <i
                className="xsui-icon xsui-icon-checkmark"
                style={{ fontSize: 24, color: "inherit" }}
              />{" "}
              Connected
            </span>
          </div>
        </div>
        <div className="connection-tile">
          <div className="connection-tile__header">
            <span className="connection-tile__title">Twitter</span>
            <img
              className="connection-tile__image"
              src="//cdn.xsolla.net/publisher-v4/twitter.ad85fb.svg"
            />
          </div>
          <div className="connection-tile__action">
            <span className="connection-tile__action_connected">
              <i
                className="xsui-icon xsui-icon-checkmark"
                style={{ fontSize: 24, color: "inherit" }}
              />{" "}
              Connected
            </span>
          </div>
        </div>
        <div className="connection-tile">
          <div className="connection-tile__header">
            <span className="connection-tile__title">Vimeo</span>
            <img
              className="connection-tile__image"
              src="//cdn.xsolla.net/publisher-v4/vimeo.0389ae.svg"
            />
          </div>
          <div className="connection-tile__action">
            <span className="connection-tile__action_connected">
              <i
                className="xsui-icon xsui-icon-checkmark"
                style={{ fontSize: 24, color: "inherit" }}
              />{" "}
              Connected
            </span>
          </div>
        </div>
        <div className="connection-tile">
          <div className="connection-tile__header">
            <span className="connection-tile__title">VK</span>
            <img
              className="connection-tile__image"
              src="//cdn.xsolla.net/publisher-v4/vk.261a1e.svg"
            />
          </div>
          <div className="connection-tile__action">
            <span className="connection-tile__action_connected">
              <i
                className="xsui-icon xsui-icon-checkmark"
                style={{ fontSize: 24, color: "inherit" }}
              />{" "}
              Connected
            </span>
          </div>
        </div>
        <div className="connection-tile">
          <div className="connection-tile__header">
            <span className="connection-tile__title">WeChat</span>
            <img
              className="connection-tile__image"
              src="//cdn.xsolla.net/publisher-v4/wechat.4b7b6a.svg"
            />
          </div>
          <div className="connection-tile__action">
            <span className="connection-tile__action_connected">
              <i
                className="xsui-icon xsui-icon-checkmark"
                style={{ fontSize: 24, color: "inherit" }}
              />{" "}
              Connected
            </span>
          </div>
        </div>
        <div className="connection-tile">
          <div className="connection-tile__header">
            <span className="connection-tile__title">Weibo</span>
            <img
              className="connection-tile__image"
              src="//cdn.xsolla.net/publisher-v4/weibo.33c904.svg"
            />
          </div>
          <div className="connection-tile__action">
            <span className="connection-tile__action_connected">
              <i
                className="xsui-icon xsui-icon-checkmark"
                style={{ fontSize: 24, color: "inherit" }}
              />{" "}
              Connected
            </span>
          </div>
        </div>
        <div className="connection-tile">
          <div className="connection-tile__header">
            <span className="connection-tile__title">Yahoo</span>
            <img
              className="connection-tile__image"
              src="//cdn.xsolla.net/publisher-v4/yahoo.57a7df.svg"
            />
          </div>
          <div className="connection-tile__action">
            <span className="connection-tile__action_connected">
              <i
                className="xsui-icon xsui-icon-checkmark"
                style={{ fontSize: 24, color: "inherit" }}
              />{" "}
              Connected
            </span>
          </div>
        </div>
        <div className="connection-tile">
          <div className="connection-tile__header">
            <span className="connection-tile__title">Yandex</span>
            <img
              className="connection-tile__image"
              src="//cdn.xsolla.net/publisher-v4/yandex.7084c8.svg"
            />
          </div>
          <div className="connection-tile__action">
            <span className="connection-tile__action_connected">
              <i
                className="xsui-icon xsui-icon-checkmark"
                style={{ fontSize: 24, color: "inherit" }}
              />{" "}
              Connected
            </span>
          </div>
        </div>
        <div className="connection-tile">
          <div className="connection-tile__header">
            <span className="connection-tile__title">YouTube</span>
            <img
              className="connection-tile__image"
              src="//cdn.xsolla.net/publisher-v4/youtube.54c7cc.svg"
            />
          </div>
          <div className="connection-tile__action">
            <span className="connection-tile__action_connected">
              <i
                className="xsui-icon xsui-icon-checkmark"
                style={{ fontSize: 24, color: "inherit" }}
              />{" "}
              Connected
            </span>
          </div>
        </div>
      </div>
    </div>
  </FormGroup>
  )
}
